import { setScrollBehavior } from "features/scrollPageBehaviorProvider/scrollPageBehaviorProvider";
import client from "libs/client";
import { useEffect } from "react";
import { useParams } from "react-router";
import SkeletonBox from "ui-kit/src/Skeleton/SkeletonBox";
import ForbiddenPage from "./errorPages/ForbiddenPage";
import NotFoundPage from "./errorPages/NotFoundPage";
import ServerErrorPage from "./errorPages/ServerErrorPage";
import { DiscoverBreadcrumbs } from "features/discover/DiscoverBreadcrumbs";
import { DISCOVER_GAME_V2_DETAIL_QUERY_KEY } from "features/discover/gameDetail/v2/constants";
import { DiscoverGameDetailV2 } from "features/discover/gameDetail/v2/DiscoverGameDetailV2";
import { _ } from "i18n";

export function DiscoverGamePageV2() {
	const { id } = useParams();
	const gameId = parseInt(id || "");

	useEffect(() => {
		setScrollBehavior();
	}, []);

	const {
		data: response,
		isLoading,
		error,
	} = client.getDiscoverGameV2.useQuery(
		{ id: gameId },
		{ queryKey: [DISCOVER_GAME_V2_DETAIL_QUERY_KEY, gameId] },
	);

	if (error) {
		const code = error?.response?.status;
		if (code === 404) {
			return <NotFoundPage />;
		}
		if (code === 403) {
			return <ForbiddenPage />;
		}
		return <ServerErrorPage />;
	}

	if (isLoading) {
		return (
			<div className="discover-container">
				<div className="pageHeading">
					<SkeletonBox style={{ width: "300px", height: "32px", margin: "35px 0 35px 0" }} />
				</div>
				<SkeletonBox style={{ width: "100%", height: "400px" }} />
			</div>
		);
	}

	const data = response?.data;
	if (!data) {
		return <NotFoundPage />;
	}

	return (
		<div className="discover-container">
			<div className="pageHeading">
				<DiscoverBreadcrumbs
					items={[
						{ label: _("discover.gameDetail.breadcrumb.games"), route: "/discover/v2/games" },
						{ label: `${data.id}`, note: data.id },
					]}
				/>
			</div>
			<DiscoverGameDetailV2 key={data.id} gameData={data} />
		</div>
	);
}
